import { Inject, Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { ASF } from '@augusoft/asf-core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanLoad {

  constructor(
    @Inject('loginRoute') loginRoute: string,
    private authService: AuthService,
    private router: Router
    ) {
      ASF.warn('Auth guard created', {loginRoute});
      if (loginRoute !== undefined) {
        this.authService.setLoginUrl(loginRoute);
      }
      // this.loginUrl = this.authService.loginUrl;
  }

  get loginUrl() {
    return this.authService.loginUrl;
  }

  canLoad(): boolean {
    const result = this.authService.isLoggedIn();
    if (!result) {
      ASF.debug('No access to this moudle, redirecting to login page:', this.authService.loginUrl);
      this.router.navigateByUrl(this.authService.loginUrl)
    }
    return result;
  }
}
